import React from 'react';
import { useDrag } from 'react-dnd';
import { Card, Button, IconCheckmark16, colors } from '@dhis2/ui';

const DraggableGoalCard = ({ goal, isSelected, onSelect }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'GOAL',
        item: { goal },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
    }));

    const handleSelect = () => {
        onSelect(goal.id);
    };

    return (
        <div
            ref={drag}
            style={{
                opacity: isDragging ? 0.5 : 1,
                cursor: isSelected ? 'default' : 'move',
                marginBottom: '12px',
                position: 'relative',
                border: isSelected ? `2px solid ${colors.green700}` : '2px solid transparent',
                borderRadius: '8px',
                transition: 'all 0.2s ease',
            }}
            onClick={handleSelect} // Make entire card clickable
        >
              
                <div style={{ padding: '12px', border: '2px solid #ddd', borderRadius: '12px',  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", backgroundColor: '#f6fcf9ff' }}> 
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'flex-start',
                        marginBottom: '8px',
                    }}>
                        <h4 style={{ 
                            margin: 0, 
                            color: isSelected ? colors.green700 : '#2c6693',
                            fontSize: '0.9rem',
                            flex: 1
                        }}>
                            {isSelected && '✅ '}{goal.name}
                        </h4>
                        
                        {isSelected && (
                            <Button
                                small
                                icon={<IconCheckmark16 />}
                                style={{ 
                                    marginLeft: '8px',
                                    backgroundColor: colors.green700,
                                    color: 'white'
                                }}
                                title="Goal selected"
                                disabled
                            />
                        )}
                    </div>
                    
                    <p style={{ 
                        margin: '0 0 8px 0', 
                        fontSize: '0.8rem',
                        color: '#666',
                        lineHeight: '1.4'
                    }}>
                        {goal.description}
                    </p>
                    
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontSize: '0.75rem',
                        color: '#888'
                    }}>
                        <span>Progress: {goal.progress}%</span>
                        <span style={{
                            padding: '2px 6px',
                            borderRadius: '12px',
                            backgroundColor: 
                                goal.priority === 'high' ? '#ff4d4f20' :
                                goal.priority === 'medium' ? '#faad1420' : '#52c41a20',
                            color: 
                                goal.priority === 'high' ? '#ff4d4f' :
                                goal.priority === 'medium' ? '#faad14' : '#52c41a'
                        }}>
                            {goal.priority}
                        </span>
                    </div>
                </div>
            
        </div>
    );
};

export default DraggableGoalCard;